import React from 'react';
import {observer} from 'mobx-react';

//helpers
import {styleable} from 'decorators';
import {useStore} from 'hooks/useStore';
import {getFixedExtensionFromUrl, getThumbnail, getVideoPlaybackUrl, isVideoUrl} from 'utils/media-utils';

//components
import CloudinaryPictureWithControls from 'components/CloudinaryPictureWithControls';
import {VideoPlayerDesktop} from 'components/VideoPlayer';

const StepMediaComponent = ({
  autoplayVideo,
  imageSizes,
  mediaUrl,
  metadata = {},
  optimizedVideos,
  shouldShowSpinnerWhileLoading
}) => {
  if (isVideoUrl(mediaUrl)) {
    return (
      <VideoPlayerDesktop
        autoplayVideo={autoplayVideo}
        muted={!metadata.enableAudio}
        poster={getThumbnail(mediaUrl)}
        src={getVideoPlaybackUrl(mediaUrl, {enableAudio: metadata.enableAudio, optimizedVideos})}
        type={`video/${getFixedExtensionFromUrl(mediaUrl)}`}
      />
    );
  }

  return (
    <CloudinaryPictureWithControls
      metadata={metadata}
      aspectRatio={4 / 3}
      src={mediaUrl}
      sizes={imageSizes}
      shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
      shouldShowOverlayShapes={true}
    />
  );
};

const StyleableStepMedia = styleable(StepMediaComponent);

export default observer(props => {
  const {platform} = useStore();
  return <StyleableStepMedia {...props} optimizedVideos={platform.hasOptimizedVideos} />;
});
